import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "nav-list" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, "首页"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://tencent.github.io/tmagic-editor/docs/",
    target: "_blank"
  }, "帮助文档")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-user" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, { class: "m-header" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, { span: 12 }, {
        default: _withCtx(() => [
          (!_ctx.$route.meta.hideAside && _ctx.aside && _ctx.aside.data.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["aside-trigger", { active: _ctx.aside.collapse }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('asideTrigger')))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass({
            'el-icon-s-fold': !_ctx.aside.collapse,
            'el-icon-s-unfold': _ctx.aside.collapse,
          })
                }, null, 2)
              ], 2))
            : _createCommentVNode("", true),
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, {
        class: "user",
        span: 12
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createElementVNode("span", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.userName), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}